export class FailedSendsPayloadBuilder {
  static buildSendPayload(orders, payment, includeSaveChanges = false) {
    const actions = orders.map(order => ({
      id: order.id,
      additional_data: {
        address: this.buildAddressPayload(order.recipient)
      },
      ...(includeSaveChanges && {
        save_changes: order.recipient.checked === true
      })
    }));

    return {
      actions,
      ...(payment && { payment })
    };
  }

  static buildCalculatePayload(orders) {
    return {
      actions: orders.map(order => ({
        id: order.id,
        additional_data: {
          address: this.buildAddressPayload(order.recipient)
        }
      }))
    };
  }

  static buildDismissPayload(orders) {
    return {
      actions: orders.map(order => ({ id: order.id }))
    };
  }

  static buildAddressPayload(recipient) {
    return {
      street: recipient.street || null,
      apt: recipient.apt || null,
      city: recipient.city || null,
      region: recipient.region || null,
      region_code: recipient.region_code || null,
      postcode: recipient.postcode || null,
      telephone: recipient.telephone || null,
      country: recipient.country || null,
    };
  }
}
